import {
  Activity, MessageCircleMore, Link, Trophy
} from "lucide-react";

export const projects = [
  {
    name: "Achievely",
    icon: <Trophy />,
    description: "Achievely is a Steam achievement monitor that lets you track, hunt, and explore achievements across your Steam library — all in one clean interface.",
    url: "https://achievely.onrender.com/",
    github: "https://github.com/Hamood268/achievely",
    image: "https://i.ibb.co/KxB6WF10/Achievely-OG.png"
  },
  {
    name: "PulseWatch",
    icon: <Activity />,
    description: "API monitoring dashboard with real-time updates and stats.",
    url: "https://pulsewatch-led1.onrender.com/",
    github: "https://github.com/Hamood268/PulseWatch",
    image: "https://i.ibb.co/6097zKc9/Pulse-Watch-OG.png"
  },
  {
    name: "GlowChat",
    icon: <MessageCircleMore />,
    description: "Real-time chat application",
    url: "https://glowchat-gyfw.onrender.com/",
    github: "https://github.com/Hamood268/GlowChat",
    image: "https://i.ibb.co/RGf7Zwfk/Glow-Chat-trans.png"
  },
  {
    name: "LinkSpark",
    icon: <Link />,
    description: "Efficient URL Shortner",
    url: "https://linkspark-ngoh.onrender.com/",
    github: "https://github.com/Hamood268/LinkSpark",
    image: "https://i.ibb.co/99ksx5Lh/link-Spark-trans.png"
  },
];

export const skills = [
  "Node.js",
  "Express",
  "MongoDB",
  "REST APIs",
  "JWT & Auth",
];
